import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { VehicleTyreReplacement } from "models";

type TyreNetOrderPayload = {
  appointment_id: number;
  ean: string;
  quantity: number;
  order_reference: string;
  order_remarks: string;
};

const isNotOrderedYet = (replacement: VehicleTyreReplacement, order: TyreNetOrderPayload) => !replacement.order_placed && replacement.tyre?.ean === order.ean;

// TODO: this is will go wrong if you have two time the same ean offered on two different position, but you order 1, then this will mark 1 as ordered and the WS message will mark the other 1 as ordered
// we just go though and mark the first we find that match as ordered, instead we must get the replacement ids from the backend as result of this endpoint, so we can mark the proper ones that was ordered
export const useOrderTyreNetMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: TyreNetOrderPayload) => ApiInstance.post("/catalog/order", payload, ENV.tyreNetBaseURLV2),
    onSuccess: payload => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.car?.tyres?.length || appointment.id !== payload.appointment_id) return;

      let quantityOrdered = payload.quantity;
      const tyres = appointment.car.tyres.map(tyre =>
        quantityOrdered > 0 && tyre.replacements?.some(r => isNotOrderedYet(r, payload))
          ? {
              ...tyre,
              replacements: tyre.replacements.map(replacement => {
                if (isNotOrderedYet(replacement, payload)) {
                  quantityOrdered--;
                  return { ...replacement, order_placed: true };
                }

                return replacement;
              })
            }
          : tyre
      );

      if (quantityOrdered === payload.quantity) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, car: { ...appointment.car, tyres } });
    }
  });
